<div class="page-heading" style="background-color: white; padding: 20px 0px 10px 0px;">
    <div class="row" style="margin: 0px;">
        <div class="col-1">
            <button type="button" *ngIf="this.nextPreviousEventIds.nextId" (click)="changeToOtherEvent('next')"
                class="btn btn-default">
                <i class="fa fa-arrow-left"></i>
            </button>
        </div>
        <div class="col text-center">
            <h2 style="margin: 0px;"><strong>{{event.eventName}}</strong></h2>
        </div>
        <div class="col-1 text-right">
            <button type=" button" *ngIf="this.nextPreviousEventIds.previousId" (click)="changeToOtherEvent('prev')"
                class="btn btn-default">
                <i class="fa fa-arrow-right"></i>
            </button>
        </div>
    </div>
    <hr />
    <div class="row" style="margin: 0px;">
        <div class="col">
            <ul class="list-group list-group-horizontal">
                <li class="list-group-item justify-content-between col" style="border:none;">
                    <div class="media">
                        <i class="fa fa-clock align-self-start mr-4"
                            style="font-size: 32px; padding-right: 20px; color: #95cc6b!important; font-weight: normal;"></i>
                        <div class="media-body">
                            <span class="m-0 text-muted">Status</span>
                            <h5 class="m-0" style="color: #95cc6b!important;">
                                <strong [innerHTML]="event.status | eventStatus:event.startDate:event.endDate"></strong>
                            </h5>
                        </div>
                    </div>
                </li>
                <li class="list-group-item justify-content-between col" style="border:none;">
                    <div class="media">
                        <i class="fa fa-calendar-alt align-self-start mr-4"
                            style="font-size: 32px; padding-right: 20px; color: #9e5ba1!important; font-weight: normal;"></i>
                        <div class="media-body">
                            <span class="m-0 text-muted">Start date</span>
                            <h5 class="m-0" style="color: #9e5ba1!important; ">
                                <strong>{{event.startDate | date:'dd-MM-yyyy'}}</strong></h5>
                        </div>
                    </div>
                </li>
                <li class="list-group-item justify-content-between col" style="border:none;">
                    <div class="media">
                        <i class="fa fa-calendar-alt align-self-start mr-4"
                            style="font-size: 32px; padding-right: 20px; color: #9e5ba1!important; font-weight: normal;"></i>
                        <div class="media-body">
                            <span class="m-0 text-muted">End date</span>
                            <h5 class="m-0" style="color: #9e5ba1!important; ">
                                <strong>{{event.endDate | date:'dd-MM-yyyy'}}</strong></h5>
                        </div>
                    </div>
                </li>
                <li class="list-group-item justify-content-between col" style="border:none;">
                    <div class="media">
                        <i class="fa fa-car-side align-self-start mr-4"
                            style="font-size: 32px; padding-right: 20px; color: #2ba8e3!important;"></i>
                        <div class="media-body">
                            <span class="m-0 text-muted">Pickup date</span>
                            <h5 class="m-0" style="color: #2ba8e3!important;">
                                <strong>{{event.pickUpDate | date:'dd-MM-yyyy'}}</strong></h5>
                        </div>
                    </div>
                </li>
                <li class="list-group-item justify-content-between col" style="border:none;">
                    <div class="media">
                        <i class="fa fa-car-side align-self-start mr-4"
                            style="font-size: 32px; padding-right: 20px; color: #2ba8e3!important;"></i>
                        <div class="media-body">
                            <span class="m-0 text-muted">Return date</span>
                            <h5 class="m-0" style="color: #2ba8e3!important;">
                                <strong>{{event.returnDate | date:'dd-MM-yyyy'}}</strong></h5>
                        </div>
                    </div>
                </li>
                <li class="list-group-item justify-content-between col" style="border:none;">
                    <div class="media">
                        <i class="fa fa-building align-self-start mr-4"
                            style="font-size: 32px; padding-right: 20px; font-weight: normal;"></i>
                        <div class="media-body">
                            <span class="m-0 text-muted">Company Name</span>
                            <h5 class="m-0">
                                <strong><a href="companies/details/{{event.clientUser.company.id}}" target="_blank"><i
                                            class="fa fa-share"></i> {{event.clientUser.company.name}}</a></strong></h5>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="container-fluid mt-3 mb-3">
    <div class="row">
        <div class="col-7">
            <div class="card mb-3">
                <div class="card-body">
                    <ng-container *ngIf="event.status === 1; else elseTemplate">
                        <button type="button" class="btn btn-success btn-sm mr-2 btn-wd">
                            <i class="fa fa-check"></i>
                            Approve Event</button>
                        <button type="button" class="btn btn-danger btn-sm mr-2 btn-wd" (click)="denyEventClick()"><i
                                class="fa fa-minus-circle"></i> Deny Event</button>
                    </ng-container>
                    <ng-template #elseTemplate>
                        <a href="events/delivery-paper/{{event.id}}" target="_blank"
                            class="btn btn-primary btn-sm mr-2 btn-wd"><i class="fa fa-paperclip"></i>Delivery
                            Paper</a>
                        <a href="events/advertise-event/{{event.id}}" class="btn btn-warning btn-sm mr-2 btn-wd"><i
                                class="fa fa-paperclip"></i>Advertise
                            Event</a>
                    </ng-template>
                    <button type="button" class="btn btn-danger btn-sm mr-2 btn-wd float-right"
                        (click)="openForceDeleteModal()"><i class="fa fa-radiation-alt"></i>Force
                        Delete</button>
                </div>
            </div>
            <div class="card">
                <div class="card-header text-uppercase">
                    <i class="fa fa-calendar-check"></i>Event
                </div>
                <div class="card-body">
                    <ul ngbNav #editorNav="ngbNav">
                        <li [ngbNavItem]="'requested-tab'">
                            <a ngbNavLink>Requested</a>
                            <ng-template ngbNavContent>
                                <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                    <app-requested-hardware-software-table [event]="event">
                                    </app-requested-hardware-software-table>
                                </div>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="'add-tab'" [disabled]="eventFinished">
                            <a ngbNavLink>Add</a>
                            <ng-template ngbNavContent>
                                <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                    <app-request-event-hardware-software [currentEvent]="event"
                                        (onEventUpdate)="onEventUpdate($event)"
                                        (onDeviceUserGenereated)="onDeviceUserGenereated($event)"
                                        >
                                    </app-request-event-hardware-software>
                                </div>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="'add-services-tab'" [disabled]="eventFinished">
                          <a ngbNavLink>Add services</a>
                          <ng-template ngbNavContent>
                              <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                <app-request-event-additional-cost [event]="event"
                                  (onEventUpdate)="onEventUpdate($event)"
                                >
                                </app-request-event-additional-cost>
                              </div>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="'summary-tab'" [disabled]="eventFinished">
                            <a ngbNavLink>Summary</a>
                            <ng-template ngbNavContent>
                                <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                    <app-requested-hardware-software-summary [requestedCable]="event.requestedCable"
                                        [requestedDevices]="event.requestedDevices"
                                        [requestedPrinterTypes]="event.requestedPrinterTypes"
                                        [requestedRouterTypes]="event.requestedRouterTypes"
                                        [requestedSoftwareTypes]="event.requestedSoftwareTypes"
                                        [requestedUps]="event.requestedUps">
                                    </app-requested-hardware-software-summary>
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="editorNav"></div>
                    <hr />
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col text-center">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="deliveryRadio"
                                            id="pickupRadio" [(ngModel)]="event.delivery" [value]="false"
                                            (change)="onDeliveryTypeRadioChange(false)">
                                        <label class="custom-control-label text-uppercase" for="pickupRadio"
                                            style="padding-top: 3px;"><strong>Abholung der Geräte in einem unserer
                                                Büros</strong></label>
                                    </div>
                                </div>
                                <div class="col text-center">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="deliveryRadio"
                                            id="deliveryId" [(ngModel)]="event.delivery" [value]="true"
                                            (change)="onDeliveryTypeRadioChange(true)">
                                        <label class="custom-control-label text-uppercase" for="deliveryId"
                                            style="padding-top: 3px;"><strong>Zustellung der Geräte
                                                per Kurier</strong></label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <ng-container *ngIf="event.delivery === false">
                                <div class="row mt-3" style="min-height: 326px;">
                                    <div class="col text-center" *ngFor="let pickupPoint of pickupPoints">
                                        <div class="custom-control custom-radio">
                                            <input type="radio" class="custom-control-input" name="originPlace"
                                                id="originPlace{{pickupPoint.name}}" [(ngModel)]="choosenPickupPoint"
                                                [value]="pickupPoint.id">
                                            <label class="custom-control-label" for="originPlace{{pickupPoint.name}}"
                                                style="padding-top: 3px;"><strong>{{pickupPoint?.nameLangKey | translate}}</strong>
                                                <br />
                                                {{pickupPoint?.addressLangKey | translate}} <br />
                                                {{pickupPoint?.postCode | translate}}
                                                {{pickupPoint?.cityLangKey | translate}}
                                                <br />
                                                {{pickupPoint?.country.name}}</label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="event.delivery === true">
                                <div class="row mt-3" style="min-height: 326px;">
                                    <div class="offset-2 col-8">
                                        <fieldset class="scheduler-border">
                                            <div class="row">
                                                <div class="col-4">
                                                    <app-form-group-select-validation label="Country *" name="language"
                                                        id="language" formControlNameValue="country"
                                                        [options]="countriesOptions" [formGroup]="deliveryAddressForm"
                                                        ngDefaultControl></app-form-group-select-validation>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <app-form-group-input-validation inputType="text"
                                                        label="First and last Name *" name="firstLastName"
                                                        id="firstLastName" placeHolder="First and last Name *"
                                                        formControlNameValue="firstLastName"
                                                        [error]="deliveryAddressErrorArray['firstLastName']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label class="control-label col-form-label-sm">Address *</label>
                                                        <div class="row no-gutters">
                                                            <div class="col" [formGroup]="deliveryAddressForm">
                                                                <input type="text"
                                                                    class="form-control form-control-sm {{deliveryAddressErrorArray['address'] ? 'is-invalid' : ''}}"
                                                                    formControlName="address" />
                                                                <div class="invalid-feedback"
                                                                    [hidden]="!deliveryAddressErrorArray['address']">
                                                                    {{deliveryAddressErrorArray['address'] | translate}}
                                                                </div>
                                                            </div>
                                                            <div class="col" [formGroup]="deliveryAddressForm">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    placeholder="Scala, piano, interno ecc. (Opzionale)"
                                                                    formControlName="addressDetails" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <app-form-group-input-validation inputType="text" label="City *"
                                                        name="city" id="city" placeHolder="City *"
                                                        formControlNameValue="city"
                                                        [error]="deliveryAddressErrorArray['city']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                                <div class="col">
                                                    <app-form-group-input-validation inputType="text" label="Province *"
                                                        name="province" id="province" placeHolder="Province *"
                                                        formControlNameValue="province"
                                                        [error]="deliveryAddressErrorArray['province']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                                <div class="col">
                                                    <app-form-group-input-validation inputType="text"
                                                        label="Post code *" name="postcode" id="postcode"
                                                        placeHolder="Post code *" formControlNameValue="postcode"
                                                        [error]="deliveryAddressErrorArray['postcode']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <app-form-group-input-validation inputType="text"
                                                        label="Phone number *" name="phone" id="phone"
                                                        placeHolder="Phone number *" formControlNameValue="phone"
                                                        [error]="deliveryAddressErrorArray['phone']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                    <small class="form-text text-muted">Può essere utilizzato per
                                                        aiutare consegna</small>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="row mt-3">
                                <div class="col text-right">
                                    <button type="button" class="btn btn-primary btn-sm"
                                        (click)="updateDeliveryInformations()">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col" [hidden]="event.status === 1">
            <div class="card">
                <div class="card-header text-uppercase">
                    <i class="fa fa-info-circle"></i>Details
                </div>
                <div class="card-body">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="edit-event-tab" data-toggle="tab" href="#edit-event"
                                role="tab" aria-controls="edit-event" aria-selected="false"><i
                                    class="fa fa-edit"></i>Edit</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="edit-event" role="tabpanel" aria-labelledby="edit-event-tab">
                            <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                <app-edit-event-card [event]="event" (onEventUpdated)="onEventUpdated($event)">
                                </app-edit-event-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header text-uppercase">
                    <i class="fa fa-hand-holding-usd"></i>Price List
                </div>
                <div class="card-body">
                    <app-price-list-card [event]="event" [eventFinished]="eventFinished"
                        [unusedPriceListOptions]="priceListOptions"
                        (onPriceListAssignedEvent)="onPriceListAssignedEvent()"
                        (onPriceListAssignedEventB)="onPriceListAssignedEventB($event)"
                        (onPriceListRemovedEvent)="onPriceListRemovedEvent($event)">
                    </app-price-list-card>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header text-uppercase">
                    <i class="fa fa-microchip"></i>Hardware
                </div>
                <div class="card-body">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="printer-hardware-tab" data-toggle="tab"
                                href="#printer-hardware" role="tab" aria-controls="printer-hardware"
                                aria-selected="true">Printers <span class="badge badge-primary"
                                    style="font-size: 100%">{{freeRealPrinterAmount}}</span></a>
                        </li>
                        <li class="nav-item" *ngIf="hasFiscalPrinters">
                          <a class="nav-link" id="fiscal-printer-hardware-tab" data-toggle="tab" href="#fiscal-printer-hardware"
                              role="tab" aria-controls="fiscal-printer-hardware" aria-selected="false">Fiscal Printers <span
                                  class="badge badge-primary"
                                  style="font-size: 100%">{{freeRealFiscalPrinterAmount}}</span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="router-hardware-tab" data-toggle="tab" href="#router-hardware"
                                role="tab" aria-controls="router-hardware" aria-selected="false">Routers <span
                                    class="badge badge-primary"
                                    style="font-size: 100%">{{freeRealRouterAmount}}</span></a>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="printer-hardware" role="tabpanel"
                            aria-labelledby="printer-hardware-tab">
                            <app-printers-card
                                [availablePrinterOptions]="printerListOptions"
                                [availablePrinterObjects]="availablePrinterObjects" [event]="event"
                                (onPrinterAddEvent)="populatePrinterSelect()"
                                (onPrinterRemoveEvent)="populatePrinterSelect()" [eventFinished]="eventFinished"
                                [freeRealPrinterAmount]="freeRealPrinterAmount">
                            </app-printers-card>
                        </div>
                        <div class="tab-pane fade" id="fiscal-printer-hardware" role="tabpanel"
                          aria-labelledby="fiscal-printer-hardware-tab">
                          <app-fiscal-printers-card
                            [availablePrinterOptions]="fiscalPrinterListOptions"
                            [availablePrinterObjects]="availableFiscalPrinterObjects" [event]="event"
                            (onPrinterAddEvent)="populateFiscalPrinterSelect()"
                            (onPrinterRemoveEvent)="populateFiscalPrinterSelect()" [eventFinished]="eventFinished"
                            [freeRealPrinterAmount]="freeRealFiscalPrinterAmount">
                          </app-fiscal-printers-card>
                        </div>
                        <div class="tab-pane fade" id="router-hardware" role="tabpanel"
                            aria-labelledby="router-hardware-tab">
                            <app-routers-card [availableRouterOptions]="routerListOptions"
                                [availableRouterObjects]="availableRouterObjects" [event]="event"
                                (onRouterAddEvent)="populateRouterSelect()"
                                (onRouterRemoveEvent)="populateRouterSelect()" [eventFinished]="eventFinished"
                                [freeRealRouterAmount]="freeRealRouterAmount">
                            </app-routers-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3" [hidden]="event.status === 1">
        <div class="col">
            <div class="card">
                <div class="card-header text-uppercase">
                    <i class="fa fa-users-cog"></i>Device Users
                </div>
                <div class="card-body">
                    <app-device-users-card [deviceUsers]="event?.deviceUsers" [eventFinished]="eventFinished"
                        [assignedPriceListObjects]="event.priceLists" [devicesListOptions]="devicesListOptions"
                        [event]="event"
                        [availableDevicesObjects]="availableDevicesObjects"
                        (onDeviceUserChange)="onDeviceUserChange($event)"
                        (onDeviceUserGenereted)="onDeviceUserGenereated($event)">
                    </app-device-users-card>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3"
        [hidden]="event.deviceUsers.length === 0 || freeRealPrinterAmount > 0 || event.priceLists.length === 0">
        <div class="col">
            <div class="card">
                <div class="card-header text-uppercase">
                    <i class="fa fa-print"></i>Printer Category
                </div>
                <div class="card-body">
                    <app-assign-printer-product-category [eventId]="event.id?.toString()" [deviceUsers]="event.deviceUsers"
                        [eventFinished]="eventFinished" [notifier]="printerCategoriesComponentNotifier"
                        [printers]="event.printers">
                    </app-assign-printer-product-category>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #forceDeleteModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title m-0" id="modal-basic-title">Force delete event</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="jumbotron jumbotron-fluid m-0">
            <div class="container">
                <h1 class="display-4 text-center m-0 mb-3">{{forceDeleteModalSecureKey}}</h1>
                <div class="form-group">
                    <label>Please enter the code above</label>
                    <input type="text" class="form-control" [(ngModel)]="forceDeleteModalSecureKeyConfirmation" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer text-center" style="display: block;">
        <button type="button" class="btn btn-default btn-sm btn-wd" (click)="modal.dismiss()">Close</button>
        <button type="button" class="btn btn-danger btn-sm btn-wd" (click)="forceDeleteEvent()">Delete</button>
    </div>
</ng-template>
